import React from 'react';
import CategoryExplorerCard, { type CategoryExplorerItem } from './CategoryExplorerCard';
import Reveal from '../ui/Reveal';
import { useRevealOnScroll } from '../../hooks/useRevealOnScroll';

interface CategoryCardsSectionProps {
  id?: string;
  items: CategoryExplorerItem[];
  className?: string;
}

const CategoryCardsSection: React.FC<CategoryCardsSectionProps> = ({
  id,
  items,
  className = '',
}) => {
  const { ref: headerRef, visible: headerVisible } = useRevealOnScroll<HTMLElement>();

  return (
    <section
      {...(id ? { id } : {})}
      className={`category-cards-section ${id ? 'scroll-mt-28 md:scroll-mt-32' : ''} bg-brand-graphite py-10 md:py-14 lg:py-16 ${className}`}
    >
      <div className="mx-auto w-full max-w-[1440px] px-4 sm:px-5 lg:px-6">
        <header
          ref={headerRef}
          className={`reveal-up mb-8 md:mb-10 lg:mb-12 ${headerVisible ? 'reveal-up--visible' : ''}`}
        >
          <p className="eyebrow-accent mb-3">01 - Explorer</p>
          <div
            className={`accent-dash mt-3 reveal-line ${headerVisible ? 'reveal-line--visible' : ''}`}
            aria-hidden
          />
          <div className="max-w-2xl">
            <h2 className="mt-5 whitespace-nowrap font-display text-[1.65rem] font-medium leading-[1.1] tracking-[-0.02em] text-white sm:text-[1.85rem] lg:mt-6 lg:text-[2.35rem] xl:text-[2.5rem]">
              Trois univers,{' '}
              <span className="font-medium text-orange-500">votre projet.</span>
            </h2>
            <p className="mt-4 max-w-xl text-[15px] font-normal leading-[1.65] text-white sm:mt-5 sm:text-base lg:text-[17px]">
              Résidences signatures, terrains à bâtir et espaces professionnels en Bretagne Sud.
            </p>
          </div>
        </header>

        <div
          className={`reveal-stagger grid grid-cols-1 gap-4 sm:grid-cols-3 sm:gap-4 lg:gap-5 ${headerVisible ? 'reveal-stagger--active' : ''}`}
        >
          {items.map((item) => (
            <CategoryExplorerCard key={item.id} item={item} />
          ))}
        </div>

        <Reveal delay={2} className="category-cards-section__footer mt-6 sm:mt-8">
          <p className="text-[10px] font-normal leading-[1.65] text-white sm:text-[11px]">
            Chaque programme raconte une histoire en devenir, visuels d&apos;ambiance, surfaces et
            conditions susceptibles d&apos;évoluer. Pour découvrir la version la plus juste de votre
            projet, échangez avec nos équipes en Bretagne Sud.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default CategoryCardsSection;
